function convertKnotsToMach(num) {
  let eq =
    "Converting " +
    num +
    " knots to mach: \n" +
    num +
    " / 661.4708 = ";
  let rep = num / 661.4708;
  return eq + rep.toFixed(3);
}

function convertKnotsToMPH(num) {
  let eq =
    "Converting " +
    num +
    " knots to miles per hour: \n" +
    num +
    " * 1.150779 = ";
  let rep = num * 1.150779;
  return eq + rep.toFixed(3);
}

function convertKnotsToKPH(num) {
  let eq =
    "Converting " +
    num +
    " knots to kilometers per hour: \n" +
    num +
    " * 1.852 = ";
  let rep = num * 1.852;
  return eq + rep.toFixed(3);
}

export { convertKnotsToMach, convertKnotsToMPH, convertKnotsToKPH };
